import React from "react";

import * as S from "./styles";

export const Slide7: React.FC = () => {
  return (
    <S.Container>
      <S.Photo />
      <S.Photo2>
        <S.Text>
          Blazer, Moun, R$ 449. Maiô, Haight, R$ 448. Brincos, R$ 149 (orelha
          direita) e R$ 289 (orelha esquerda), e anéis, R$ 129 (cada um), tudo
          Eduardo Caires.
        </S.Text>
      </S.Photo2>
      <S.Photo3>
        <S.Credit>
          Maiô, Haight, R$ 448. Brinco, R$ 289, Eduardo Caires.
        </S.Credit>
      </S.Photo3>
    </S.Container>
  );
};
